import { qzTrayCertificateApi } from '../../api';
import {
  QzTrayCertificateType,
  QzTrayGenerateCertificateRequest,
} from '../../types/qztray/QzTrayCertificateTypes';

const QzTrayCertificateService = {
  uploadCertificate: async (file: File, type: QzTrayCertificateType) => {
    const payload = { type };
    const response = await qzTrayCertificateApi.postFormData(payload, file);
    return response.data;
  },

  generateCertificate: async (request: QzTrayGenerateCertificateRequest) => {
    const response = await qzTrayCertificateApi.addCustom('/generate', request);
    return response.data;
  },

  downloadCertificate: async (type: QzTrayCertificateType) => {
    return qzTrayCertificateApi.downloadFileFromBlob(`/download/${type}`);
  },

  deleteCertificate: async (type: QzTrayCertificateType) => {
    const response = await qzTrayCertificateApi.removeCustom(`/${type}`);
    return response.data;
  },

  getAllCertificates: async () => {
    const response = await qzTrayCertificateApi.fetchAll();
    return response.data;
  },
};

export default QzTrayCertificateService;